import React, { useContext } from "react";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ApplicantProfileTabs from "../Contents/ApplicantProfile/ApplicantProfileTabs";
import { Button, IconButton, TextField } from "@mui/material";
import { Search as SearchIcon } from "@mui/icons-material";
import { useState } from "react";
import { ContextData } from "../../../context/Context";
import { Getrequest, Putrequest } from "../../../context/AxiosRequest";
import { toast } from "react-toastify";
import VerificationStatusListDialogue from "./verification/VerificationStatusListDialogue";
import SoundAlert from "../../../routes/SoundAlert";
import DisbursementStatusListDialogue from "./disbursement/DisbursementStatusListDialogue";

function Disbursement({type,name,params}) {


  const [searchText, setSearchText] = useState("");
  const {accesstoken,GlobalLoader,setGlobalLoader,Allow,UserTokens} = useContext(ContextData)
  const [ApplicantData,setApplicantData] = React.useState(null)
  const [GetToken,setGetToken] = React.useState()
  
      const GetApplicant = (user_token)=>{
  
       setGetToken(user_token)

      }
  
      React.useEffect(()=>{
  
                    async function FetchData() {
                        
                            if(type  === "DisbursementStatusListDialogue"){

                                            const response = await Getrequest(`auth/get_applicantBio_for_qualification_type/${params === undefined ? "sent_disbursment" : params }/disbursement`,accesstoken)
                                             setApplicantData(response)
                            }else{

                                  const response = await Getrequest(`auth/get_applicantBio_for_qualification_type/${params === undefined ? "disburs" : params }/disbursement`,accesstoken)
                                             setApplicantData(response)
                            }
               
                    }
    
                  FetchData()
      },[GlobalLoader])

      

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };


  const HandleVerify = async (user_token,type) => {


      if(type !== 'disqualified') {

        if(!Allow) {
  
            toast.warn("Applicant documents need verification")
            SoundAlert("error")
            return
        }

        
      }



    const data = {
      user_token,
      type,
      verifier_token: UserTokens
    };

    const response = await Putrequest( `auth/handle_verify_done_return`,data,accesstoken);
    
      toast.success(response);
      setGlobalLoader(!GlobalLoader)
      SoundAlert("success")

  }

  const [DataValue, setDataValue] = useState("loan");
  
  const handleChange = (event) => {
    setDataValue(event.target.value);
  };


  
  return (
    <div className="h-[92vh] p-6 overflow-x-hidden">

      <h1 className="font-bold text-2xl"> {name !== undefined ? name : "Disbursement"} </h1>
 

          {
            type !== "DisbursementStatusListDialogue" &&
        <div className="flex justify-center items-center mb-4 mt-4 gap-4">
          <p className="whitespace-nowrap">Select Application Type:</p>
            <select
        onChange={handleChange}
        value={DataValue}
        className="w-full p-2 rounded-md bg-[#030323e6] text-white font-bold"
      >
       {/*  <option value="scholarship">Scholarship Applications</option> */}
        <option value="loan">Loan Applications</option>
      </select>
        </div>
          }
          {
            type !== "DisbursementStatusListDialogue" &&
          <div className="flex flex-row">
          <DisbursementStatusListDialogue
            type= "Disbursement_sent"
            Bgcolor=""
            name="disbursement_sent"
            
          />
          <DisbursementStatusListDialogue
            type="Disbursement_Approved"
            Bgcolor="green"
            name="disbursement_Approved"
          />
          </div>
          }
          
      <TextField
        label="Search"
        variant="outlined"
        value={searchText}
        onChange={handleSearchChange}
        InputProps={{
          endAdornment: (
            <IconButton>
              <SearchIcon />
            </IconButton>
          ),
        }}
        fullWidth
        margin="normal"
      />
      <div className=" d-flex items-start h-[100%]  ">
        <div
          style={{ height: "100%" }}
          className="verification-aside w-1/3 bg-slate-100 overflow-auto border-r-2 border-black border-solid"
        > 
          
          <ul className="ver-aside-ul mb-28">
            {ApplicantData !== null && ApplicantData.map((item, index) => (
              <li className={`flex justify-between whitespace-nowrap  items-center ${item.user_token === GetToken && "bg-blue-700 text-white"}`} onClick={()=> GetApplicant(item.user_token)}  key={index}>
                <span>
                <span className="pl-1 pr-1">{index + 1}.</span>
                <AccountCircleIcon /> {`${item.fname}`}
                </span>
                 <Button onClick={()=>HandleVerify(item.user_token,"disqualified")} variant="contained" sx={{background:"darkred",marginRight:"4px"}} >Disqualify</Button>
                 {
                  ( item.verify_status === "Not Verified")  && 
                <span className="flex pr-2">
                  <Button onClick={()=>HandleVerify(item.user_token,"returned")} variant="contained" sx={{background:"darkred",marginRight:"4px"}} disabled={item.user_token !== GetToken }>Return</Button>
                  <Button onClick={()=>HandleVerify(item.user_token,"verified")} variant="contained" disabled={item.user_token !== GetToken }>Verify</Button>
                  
                </span>
                 }
             
              </li> 
            ))}
          </ul> 
        </div>

        <div style={{ height: "100%", width:"100%" }} className="overflow-auto mb-40">
          <ApplicantProfileTabs sty="sty" typeForUser={"disbursmetn_unit"} applicationType={DataValue} usertoken={GetToken} from="disbursement" />
        </div>
      </div>
    </div>
  );
}

export default Disbursement;
